import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/frontend/src/components/Link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.bun/@mui+material@9.0.0+6ffb97a34087bd26/node_modules/@mui/material/Box/Box.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.bun/@mui+material@9.0.0+6ffb97a34087bd26/node_modules/@mui/material/Container/Container.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.bun/@mui+material@9.0.0+6ffb97a34087bd26/node_modules/@mui/material/Paper/Paper.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.bun/@mui+material@9.0.0+6ffb97a34087bd26/node_modules/@mui/material/Typography/Typography.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.bun/next@16.2.4+408004b0c890ffdc/node_modules/next/dist/client/script.js");
